module.exports = __webpack_public_path__ + "static/media/jai-patel.aee92fd7.jpeg";